import { render, staticRenderFns } from "./MicrolearningVideoActionsBar.vue?vue&type=template&id=08f9d823&scoped=true"
import script from "./MicrolearningVideoActionsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningVideoActionsBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningVideoActionsBar.vue?vue&type=style&index=0&id=08f9d823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9d823",
  null
  
)

export default component.exports